import { render, staticRenderFns } from "./AddClassModal.vue?vue&type=template&id=0f5b1b14&"
import script from "./AddClassModal.vue?vue&type=script&lang=js&"
export * from "./AddClassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports